<template>
	<div class="sub_contents login">
		<div class="cont_center">
			<div class="login_box_area login_box_area2">
				<div class="brand_title_row" aria-hidden="true">
					<img src="@/assets/images/header/logo.png" alt="하이비타민" class="brand_logo_img" />
					<h3 class="title_login title_inline">로그인</h3>
				</div>
				<p class="welcome_copy">카카오 계정으로 1초 로그인</p>

				<div class="login_input_area">
					<div class="login_form_area" v-if="showLegacyIdPwLogin">
						<ul class="login_input_list">
							<li>
								<InputText v-model="loginData.id" :placeholder="placeholderID"
									@input="hideErrorMessages" />
							</li>
							<li>
								<InputText v-model="loginData.password" :placeholder="placeholderPW" type="password"
									@input="hideErrorMessages" />
								<p v-if="invalidPassword" class="required login-error-message">
									로그인 정보가 올바르지 않습니다.
								</p>
							</li>
						</ul>

						<div class="login_check_area">
							<CheckBox v-for="option in checkOptions" :key="option.value" :id="option.value"
								:value="option.value" :label="option.label" v-model="selectedOptions"
								@change="onCheckboxChange" />
						</div>

						<div class="btn_login_area">
							<button @click="handleLogin" class="btn_type2">로그인</button>
						</div>

						<ul class="login_user_link">
							<li>
								<RouterLink to="/HFO_LO_002">아이디 찾기</RouterLink>
							</li>
							<li>
								<RouterLink to="/HFO_LO_005">비밀번호 찾기</RouterLink>
							</li>
						</ul>
					</div>

					<div class="sns_login_wrapper">
						<h4 class="sns_login_title">로그인</h4>
						<ul class="sns_login">
							<li class="kakao_priority_item">
								<a href="#" @click="kakaoLoginBtn" id="kakaoLogin" class="kakao_priority_link">
									<img src="@/assets/images/icon/join_kakao.png" alt="카카오로 시작하기"
										class="sns_login_img" />
								</a>
							</li>
							<li class="sns_divider" aria-hidden="true"><span>또는</span></li>
							<li class="naver_secondary_item">
								<div id="naver_id_login" style="display:none"></div>
								<a href="#" @click="redirectToNaverLogin" class="naver_secondary_link">
									<img src="@/assets/images/icon/join_naver.png" alt="네이버로 시작하기"
										class="sns_login_img" />
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<AlertPopup v-if="showAlert" :title="alertTitle" :message="alertMessage" :showClose="true"
			@close="closeAlert" />

		<LayerPopup v-model="showMarketingConsentPopup" title="마케팅 정보 수신 동의">
			<template #layer_content>
				<div class="term_check_area">
					<div class="d_check">
						<input type="checkbox" v-model="marketingConsent.checked" @change="updateMarketingSubOptions"
							id="base-popup-marketing-all" />
						<label for="base-popup-marketing-all">[선택] 통합 마케팅 정보 수신 동의</label>
					</div>

					<div class="marketing_check_area">
						<div class="d_check">
							<input type="checkbox" v-model="marketingConsent.emailChecked"
								id="base-popup-marketing-email" @change="updateMarketingChecked" />
							<label for="base-popup-marketing-email">카카오톡</label>
						</div>

						<div class="d_check">
							<input type="checkbox" v-model="marketingConsent.smsChecked" id="base-popup-marketing-sms"
								@change="updateMarketingChecked" />
							<label for="base-popup-marketing-sms">문자</label>
						</div>

						<p class="marketing_noti">하이비타민의 통합 혜택 및 이벤트 안내를 카카오톡/문자로 받아보실 수 있습니다.</p>
					</div>

					<div class="layer_term_area" v-html="marketingTermsContent"></div>

					<div class="btn_login_area popup_actions">
						<button type="button" class="btn_type2" @click="confirmMarketingConsent">동의하고 계속</button>
					</div>
				</div>
			</template>
		</LayerPopup>
	</div>
</template>

<script>
import { onBeforeMount, ref } from "vue";
import { useRoute, useRouter } from "vue-router";   // ← 이 줄 추가
import InputText from "@/components/InputText";
import CheckBox from "@/components/CheckBox";
import AlertPopup from "@/components/AlertPopup.vue";
import LayerPopup from "@/components/LayerPopup.vue";
import { postAxios, getAxios, putAxios } from "@/lib/AxiosCall";
import {
	LOCAL_STORAGE_HVM_SAVED_ID,
	LOCAL_STORAGE_HVM_USERINFO,
} from "@/lib/Constant";
import axios from "axios";
import { getKakaoAppKey, ensureKakaoInitialized } from "@/lib/SocialAuth";
import { encryptAES256 } from "@/lib/crypto";
import { SessionManager } from "@/lib/SessionManager";

export default {
	components: {
		InputText,
		CheckBox,
		AlertPopup,
		LayerPopup,
	},
	data() {
		return {
			loginData: { id: "", password: "" },
			placeholderID: "아이디(E-mail)를 입력해주세요.",
			placeholderPW: "비밀번호를 입력해 주세요.",
			selectedOptions: [],
			invalidPassword: false,
			checkOptions: [{ label: "아이디 저장", value: "2" }],
			showLegacyIdPwLogin: false,
			showAlert: false,
			alertTitle: "알림",
			alertMessage: "",
			kakaoHandled: false,
			showMarketingConsentPopup: false,
			marketingTermsContent: "",
			marketingConsent: {
				checked: true,
				emailChecked: true,
				smsChecked: true,
			},
			pendingMemberCheckAction: "",
			pendingMarketingUpdate: false,
		};
	},
	setup() {
		const route = useRoute();
		const router = useRouter();
		const userData = ref({
			USER_ID: "",
			USER_NAME: "",
			USER_EMAIL: "",
			USER_BIRTH: "",
			USER_GENDER: "",
			USER_IN_TYPE: "USER_IN_NORMAL",
		});
		return { route, router, userData };
	},
	mounted() {
		const { code, state, reason } = this.$route.query;

		ensureKakaoInitialized();

		this.resumeMarketingFlowIfNeeded();

		const entUuid = typeof this.$route.query.entUuid === "string"
			? this.$route.query.entUuid
			: "";
		const frcUuid = typeof this.$route.query.frcUuid === "string"
			? this.$route.query.frcUuid
			: "";
		if (!entUuid && !frcUuid) {
			this.clearStaleTenantContext();
		}

		const initialFrc = typeof this.$route.query.frcUuid === "string"
			? this.$route.query.frcUuid
			: "";
		if (initialFrc) {
			sessionStorage.setItem("foodcon_frc_uuid", initialFrc);
			sessionStorage.setItem("frcUuid", initialFrc);
		}

		// 네이버 콜백
		if (code && state) {
			this.handleNaverCallback();
		}
		// 카카오 콜백
		else if (code && !state && !this.kakaoHandled) {
			this.handleKakaoCallback();
		}

		if (reason === "session-expired") {
			this.alertMessage =
				"세션이 만료되어 자동 로그아웃되었습니다. 다시 로그인해주세요.";
			this.showAlert = true;
		}

		this.initSavedId();

		// 네이버 SDK init
		const clientId = "8OoTuF36z_kbHk8X6i4F";
		const currentOrigin = window.location.origin;
		this.naverLogin = new window.naver_id_login(
			clientId,
			`${currentOrigin}/HFO_LO_001`
		);
		const naverState = this.naverLogin.getUniqState();
		this.naverLogin.setButton("green", 3, 100);
		this.naverLogin.setDomain(currentOrigin);
		this.naverLogin.setState(naverState);
		this.naverLogin.setPopup();
		this.naverLogin.init_naver_id_login();
	},
	methods: {
		clearStaleTenantContext() {
			const tenantKeys = [
				"foodcon_ent_uuid",
				"foodcon_frc_uuid",
				"foodcon_ent_seq",
				"entUuid",
				"frcUuid",
				"entSeq",
			];

			tenantKeys.forEach((key) => {
				sessionStorage.removeItem(key);
				localStorage.removeItem(key);
			});

			try {
				const raw = sessionStorage.getItem("cps_entry_context") || localStorage.getItem("cps_entry_context");
				if (!raw) return;

				const context = JSON.parse(raw);
				delete context.entUuid;
				delete context.frcUuid;
				const serialized = JSON.stringify(context);
				sessionStorage.setItem("cps_entry_context", serialized);
				localStorage.setItem("cps_entry_context", serialized);
			} catch (_e) {
				sessionStorage.removeItem("cps_entry_context");
				localStorage.removeItem("cps_entry_context");
			}
		},
		kakaoLoginBtn() {
			ensureKakaoInitialized();
			window.Kakao.Auth.authorize({
				redirectUri: window.location.origin + "/HFO_LO_001",
				scope: "plusfriends",
			});
		},
		async handleKakaoCallback() {
			this.kakaoHandled = true;
			const code = this.$route.query.code;
			try {
				const tokenRes = await axios.post(
					"https://kauth.kakao.com/oauth/token",
					null,
					{
						params: {
							grant_type: "authorization_code",
							client_id: getKakaoAppKey(),
							redirect_uri: window.location.origin + "/HFO_LO_001",
							code,
						},
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
						},
					}
				);
				console.log("카카오 access_token:", tokenRes.data.access_token);
				window.Kakao.Auth.setAccessToken(tokenRes.data.access_token);
				sessionStorage.setItem('kakao_access_token', tokenRes.data.access_token || '');

				const profile = await window.Kakao.API.request({
					url: "/v2/user/me",
				});
				console.log("카카오 profile 전체:", profile);

				if (!profile || !profile.id) {
					alert("카카오 profile 정보가 올바르지 않습니다.");
					return;
				}

				const acct = profile.kakao_account || {};
				this.userData.USER_ID = profile.id;
				this.userData.USER_MOBILE = acct.phone_number;
				this.userData.USER_NAME = acct.name || "";
				this.userData.USER_EMAIL = acct.email || "";
				this.userData.USER_BIRTH = acct.birthday || (acct.birthyear ? acct.birthyear + "-" + acct.birthday : "");
				this.userData.USER_GENDER = acct.gender || "";
				this.userData.USER_IN_TYPE = "USER_IN_KAKAO";
				sessionStorage.setItem(LOCAL_STORAGE_HVM_USERINFO, JSON.stringify(this.userData));
				sessionStorage.setItem("userData", JSON.stringify(this.userData));
				await this.getMemberCheck(String(profile.id));
			} catch (err) {
				console.error("Kakao login error:", err);
				if (window.Kakao.Auth.getAccessToken()) {
					await window.Kakao.API.request({ url: "/v1/user/unlink" });
					window.Kakao.Auth.setAccessToken(undefined);
				}
				sessionStorage.removeItem('kakao_access_token');
				alert("카카오 로그인에 실패했습니다. 다시 시도해주세요.");
			}
		},
		redirectToNaverLogin() {
			const clientId = "8OoTuF36z_kbHk8X6i4F";
			const redirectUri = encodeURIComponent(window.location.origin + this.$route.path);
			const state = this.naverLogin.getUniqState();
			window.location.href = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}`;
		},
		async handleNaverCallback() {
			const code = this.$route.query.code;
			const state = this.$route.query.state;
			try {
				const resp = await axios.get(
					`/oauth2.0/token?grant_type=authorization_code&client_id=8OoTuF36z_kbHk8X6i4F&client_secret=alQwE9B9hk&code=${code}&state=${state}`
				);
				const token = resp.data.access_token;
				if (!token) throw new Error("토큰 조회 실패");
				await this.fetchNaverUserInfo(token);
			} catch (err) {
				console.error("Error fetching Naver token:", err);
				alert("네이버 로그인에 실패했습니다. 다시 시도해주세요.");
			}
		},
		async fetchNaverUserInfo(accessToken) {
			try {
				const { data } = await axios.get("/v1/nid/me", {
					headers: { Authorization: `Bearer ${accessToken}` },
				});
				const r = data.response;
				const user = {
					USER_ID: r.email,
					USER_NAME: r.name || r.nickname,
					USER_EMAIL: r.email,
					USER_BIRTH:
						r.birthyear && r.birthday
							? `${r.birthyear}-${r.birthday}`
							: "",
					USER_MOBILE: r.mobile || "",
					USER_GENDER: r.gender || "",
					USER_IN_TYPE: "USER_IN_NAVER",
				};
				sessionStorage.setItem(
					LOCAL_STORAGE_HVM_USERINFO,
					JSON.stringify(user)
				);
				sessionStorage.setItem("userData", JSON.stringify(user));
				await this.getMemberCheck(user.USER_ID);
			} catch (err) {
				console.error("Error fetching Naver info:", err);
				alert("네이버 사용자 정보를 가져오는 데 실패했습니다.");
			}
		},
		async getMemberCheck(id) {
			const encryptedId = encryptAES256(id);
			const frcUuid = this.resolveFrcUuid();
			const entSeq = this.resolveEntUuid();
			const entryType = String(this.$route?.query?.entryType || "").toLowerCase();
			const isCpsFlow = entryType === "cps";
			const platformUserRaw = this.resolvePlatformUserRaw();
			const memberSearchApi = isCpsFlow ? "/bgm/v1/foodcon/id" : "bgm/v1/search/id";
			const memberSearchPayload = isCpsFlow
				? {
					platformUser: encryptAES256(platformUserRaw || String(id || "").trim()),
					...(entSeq ? { entSeq } : {}),
					...(frcUuid ? { frcUuid } : {}),
				}
				: {
					userId: encryptedId,
					type: "id",
					...(entSeq ? { entSeq } : {}),
					...(frcUuid ? { frcUuid } : {}),
				};
			const res = await postAxios(memberSearchApi, memberSearchPayload);

			if (!res.id) {
				this.proceedToSignup();
			} else {
				await this.handleLogin();
			}
		},
		resolveFrcUuid() {
			const q = this.$route?.query || {};
			const byQuery = typeof q.frcUuid === "string" ? q.frcUuid : "";
			if (byQuery) {
				sessionStorage.setItem("foodcon_frc_uuid", byQuery);
				sessionStorage.setItem("frcUuid", byQuery);
				return byQuery;
			}

			try {
				const fromUrl = new URLSearchParams(window.location.search).get("frcUuid") || "";
				if (fromUrl) {
					sessionStorage.setItem("foodcon_frc_uuid", fromUrl);
					sessionStorage.setItem("frcUuid", fromUrl);
					return fromUrl;
				}
			} catch (e) {
				// ignore
			}

			return (
				sessionStorage.getItem("foodcon_frc_uuid") ||
				sessionStorage.getItem("frcUuid") ||
				localStorage.getItem("foodcon_frc_uuid") ||
				localStorage.getItem("frcUuid") ||
				""
			);
		},
		resolveEntUuid() {
			const q = this.$route?.query || {};
			const byQuery = typeof q.entUuid === "string" ? q.entUuid : "";
			if (byQuery) {
				sessionStorage.setItem("foodcon_ent_uuid", byQuery);
				sessionStorage.setItem("entUuid", byQuery);
				return byQuery;
			}

			try {
				const fromUrl = new URLSearchParams(window.location.search).get("entUuid") || "";
				if (fromUrl) {
					sessionStorage.setItem("foodcon_ent_uuid", fromUrl);
					sessionStorage.setItem("entUuid", fromUrl);
					return fromUrl;
				}
			} catch (e) {
				// ignore
			}

			return (
				sessionStorage.getItem("foodcon_ent_uuid") ||
				sessionStorage.getItem("entUuid") ||
				localStorage.getItem("foodcon_ent_uuid") ||
				localStorage.getItem("entUuid") ||
				""
			);
		},
		resolvePlatformUserRaw() {
			const q = this.$route?.query || {};
			return String(
				q.platformUser ||
				q.userId ||
				sessionStorage.getItem("platformUser") ||
				localStorage.getItem("platformUser") ||
				""
			).trim();
		},
		resolvePlatformGroupRaw() {
			const q = this.$route?.query || {};
			return String(
				q.platformGroup ||
				q.subId ||
				sessionStorage.getItem("platformGroup") ||
				localStorage.getItem("platformGroup") ||
				""
			).trim();
		},
		resolveMarketingReturnPath() {
			const q = this.$route?.query || {};
			const frcUuid = this.resolveFrcUuid();
			const entUuid = typeof q.entUuid === "string" ? q.entUuid : "";
			const params = new URLSearchParams();
			if (entUuid) params.set("entUuid", entUuid);
			if (frcUuid) params.set("frcUuid", frcUuid);
			const query = params.toString();
			return query ? `/HFO_LO_001?${query}` : "/HFO_LO_001";
		},
		async redirectToMarketingConsent(nextAction) {
			this.pendingMemberCheckAction = nextAction;
			this.pendingMarketingUpdate = true;
			await this.loadMarketingTermsContent();
			this.showMarketingConsentPopup = true;
		},
		async resumeMarketingFlowIfNeeded() {
			const isDone = sessionStorage.getItem("hvm_marketing_consent_done") === "Y";
			if (!isDone) return;

			const action = sessionStorage.getItem("hvm_marketing_next_action") || "";
			const needUpdate = sessionStorage.getItem("hvm_marketing_update_pending") === "Y";

			sessionStorage.removeItem("hvm_marketing_consent_done");
			sessionStorage.removeItem("hvm_marketing_next_action");
			sessionStorage.removeItem("hvm_marketing_return_to");
			sessionStorage.removeItem("hvm_marketing_update_pending");

			this.pendingMarketingUpdate = needUpdate;

			if (action === "signup") {
				this.proceedToSignup();
				return;
			}
			if (action === "login") {
				await this.handleLogin();
			}
		},
		async loadMarketingTermsContent() {
			if (this.marketingTermsContent) return;
			try {
				const resp = await getAxios("/hvm/v1/help/contract", {
					contractType: "CONTRACT_MARKETING",
				});
				const content = resp?.page?.list?.[0]?.rmks || "";
				this.marketingTermsContent =
					content ||
					"<p>하이비타민의 통합 마케팅 정보 수신에 동의하시면 카카오톡/문자로 이벤트, 혜택, 프로모션 안내를 받아보실 수 있습니다.</p><p>주문/결제/계정 관련 필수 안내는 동의 여부와 관계없이 발송됩니다.</p>";
			} catch (error) {
				this.marketingTermsContent =
					"<p>하이비타민의 통합 마케팅 정보 수신에 동의하시면 카카오톡/문자로 이벤트, 혜택, 프로모션 안내를 받아보실 수 있습니다.</p><p>주문/결제/계정 관련 필수 안내는 동의 여부와 관계없이 발송됩니다.</p>";
			}
		},
		updateMarketingSubOptions() {
			if (!this.marketingConsent.checked) {
				this.marketingConsent.emailChecked = false;
				this.marketingConsent.smsChecked = false;
			} else {
				this.marketingConsent.emailChecked = true;
				this.marketingConsent.smsChecked = true;
			}
		},
		updateMarketingChecked() {
			this.marketingConsent.checked =
				this.marketingConsent.emailChecked || this.marketingConsent.smsChecked;
		},
		async confirmMarketingConsent() {
			sessionStorage.setItem(
				"emailChecked",
				this.marketingConsent.emailChecked ? "true" : "false"
			);
			sessionStorage.setItem(
				"smsChecked",
				this.marketingConsent.smsChecked ? "true" : "false"
			);

			this.showMarketingConsentPopup = false;
			if (this.pendingMemberCheckAction === "signup") {
				this.proceedToSignup();
				return;
			}
			await this.handleLogin();
		},
		proceedToSignup() {
			const isKakaoUser = (this.userData?.USER_IN_TYPE || '') === 'USER_IN_KAKAO';
			this.router.push(isKakaoUser ? "/HFO_MB_004_SNS" : "/HFO_MB_003");
		},
		async handleLogin() {
			try {
				const stored = JSON.parse(
					sessionStorage.getItem(LOCAL_STORAGE_HVM_USERINFO) || "{}"
				);
				let id = encryptAES256(this.loginData.id);
				let pwd = encryptAES256(this.loginData.password);
				let type = "USER_IN_NORMAL";

				if (stored.USER_IN_TYPE !== "USER_IN_NORMAL") {
					id = encryptAES256(String(stored.USER_ID));
					pwd = "";
					type = stored.USER_IN_TYPE;
				}

				const frcUuid = this.resolveFrcUuid();
				const entSeq = this.resolveEntUuid();
				const platformUserRaw = this.resolvePlatformUserRaw();
				const platformGroupRaw = this.resolvePlatformGroupRaw();

				const resp = await postAxios("/bgm/v1/mem/login", {
					userId: id,
					userPwd: pwd,
					userInType: type,
					...(platformUserRaw ? { platformUser: encryptAES256(platformUserRaw) } : {}),
					...(platformGroupRaw ? { platformGroup: platformGroupRaw } : {}),
					...(entSeq ? { entSeq } : {}),
					...(frcUuid ? { frcUuid } : {}),
				});

				if (resp.errors) {
					this.invalidPassword = true;
					return;
				}

				localStorage.setItem(
					LOCAL_STORAGE_HVM_USERINFO,
					JSON.stringify(resp)
				);

				if (this.pendingMarketingUpdate && resp?.userUuid) {
					try {
						const emailYn = this.marketingConsent.emailChecked ? "Y" : "N";
						const smsYn = this.marketingConsent.smsChecked ? "Y" : "N";
						await putAxios(`bgm/v1/mem/member/${resp.userUuid}`, {
							emailYn,
							smsYn,
						});
						resp.emailYn = emailYn;
						resp.smsYn = smsYn;
						localStorage.setItem(
							LOCAL_STORAGE_HVM_USERINFO,
							JSON.stringify(resp)
						);
					} catch (error) {
						console.warn("마케팅 동의 저장 실패:", error);
					} finally {
						this.pendingMarketingUpdate = false;
					}
				}
				SessionManager.startSession();

				if (this.selectedOptions.includes("2")) {
					localStorage.setItem(LOCAL_STORAGE_HVM_SAVED_ID, this.loginData.id);
				} else {
					localStorage.removeItem(LOCAL_STORAGE_HVM_SAVED_ID);
				}

				if (resp.pwdChangYn === "Y") {
					this.router.push("/HFO_MP_006");
					return;
				}

				const redirect = this.$route.query.redirect || "/";
				this.router.push({ path: redirect });
			} catch (err) {
				console.error("로그인 중 오류:", err);
				this.invalidPassword = true;
			}
		},
		initSavedId() {
			const saved = localStorage.getItem(LOCAL_STORAGE_HVM_SAVED_ID);
			if (saved) {
				if (!this.selectedOptions.includes("2")) {
					this.selectedOptions.push("2");
				}
				this.loginData.id = saved;
			}
		},
		onCheckboxChange() {
			if (this.selectedOptions.includes("2")) {
				localStorage.setItem(
					LOCAL_STORAGE_HVM_SAVED_ID,
					this.loginData.id
				);
			} else {
				localStorage.removeItem(LOCAL_STORAGE_HVM_SAVED_ID);
			}
		},
		hideErrorMessages() {
			this.invalidPassword = false;
		},
		closeAlert() {
			this.showAlert = false;
		},
	},
};
</script>

<style scoped>
.popup_actions {
	margin-top: 18px;
}

.popup_actions .btn_type2 {
	width: 100%;
	height: 56px;
	line-height: 56px;
	background: #ee7528;
	color: #fff;
	border: none;
	border-radius: 5px;
	font-size: 16px;
	font-weight: 600;
	text-align: center;
	display: block;
}

.popup_actions .btn_type2:hover {
	background: #d66520;
}
</style>

<style scoped>
.login-error-message {
	margin-top: 8px !important;
	margin-bottom: 0 !important;
	display: block !important;
	clear: both !important;
	position: relative !important;
	z-index: 1 !important;
}

.login_input_list li {
	margin-bottom: 15px;
}

.brand_title_row {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
	margin-bottom: 8px;
}

.brand_logo_img {
	width: 108px;
	height: auto;
	opacity: 0.95;
}

.title_login.title_inline {
	margin: 0;
	font-size: 28px;
	line-height: 1;
}

.welcome_copy {
	text-align: center;
	margin-bottom: 16px;
	color: #3d3d3d;
	font-size: 16px;
	font-weight: 600;
	letter-spacing: -0.2px;
	line-height: 1.4;
}

.required.login-error-message {
	color: #ff4444;
	font-size: 16px;
	line-height: 1.4;
}

/* SNS 로그인 디자인 */
.sns_login_wrapper {
	position: relative;
	border: 2px solid #ee7528;
	border-radius: 5px;
	padding: 0px 10px 10px;
	margin-top: 25px;
}

.sns_login_title {
	position: absolute;
	top: -12px;
	left: 15px;
	background: #fff;
	padding: 0 8px;
	color: #ee7528;
	margin: 0;
	font-size: 16px;
}

.sns_login {
	padding: 0 !important;
	/* ul 내부 패딩 제거 */
	margin: 0 !important;
	/* ul 외부 여백 제거 */
}

.sns_login>li {
	margin-top: 12px !important;
}

.sns_login_img {
	width: 100%;
	max-width: 335px;
	height: auto;
	border-radius: 5px;
}

.sns_divider {
	position: relative;
	margin: 14px 0 4px !important;
	text-align: center;
}

.sns_divider::before {
	content: "";
	position: absolute;
	top: 50%;
	left: 0;
	right: 0;
	border-top: 1px solid #e9e9e9;
}

.sns_divider span {
	position: relative;
	z-index: 1;
	display: inline-block;
	padding: 0 10px;
	background: #fff;
	color: #999;
	font-size: 12px;
	font-weight: 500;
}

.kakao_priority_item {
	margin-top: 14px !important;
	margin-bottom: 2px;
}

.kakao_priority_link {
	display: block;
	border-radius: 8px;
	box-shadow: 0 8px 18px rgba(250, 224, 0, 0.35);
	transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.kakao_priority_link:hover {
	transform: translateY(-1px);
	box-shadow: 0 10px 22px rgba(250, 224, 0, 0.4);
}

.naver_secondary_item {
	margin-top: 8px !important;
}

.naver_secondary_link {
	display: block;
	opacity: 0.95;
}
</style>
